export enum PaymentType {
  STRIPE = 'STRIPE',
  CARD = 'CARD',
  CASH = 'CASH',
  CHECK = 'CHECK',
  TRANSFER = 'TRANSFER',
  FAKE = 'FAKE',
}
